export class ImageUtils {
    static DEFAULT_ANIMAL_ICON = 'assets/images/cow-icon.svg';
    static DEFAULT_MILK_ICON = 'assets/images/milk-icon.svg';
    static DEFAULT_COW_MANAGEMENT_ICON = 'assets/images/cow-management-icon.svg';
    static DEFAULT_BOTTLE_ICON = 'assets/images/bottle-icon.svg';
    static DEFAULT_COW_MILKING_ICON = 'assets/images/cow-milking-icon.svg';
    static DEFAULT_ANIMAL_POSITION = 'assets/images/position-animal.svg';
    static DEFAULT_CLEAN_BUTTON = 'assets/images/clean-button-icon.svg';
    static GREEN_BOTTLE_ICON = 'assets/images/green-bottle.svg';
    static COW_MILK_CONTROL_ICON = 'assets/images/cow-milk-control.svg';
    static CLOCK_MILK_CONTROL_ICON = 'assets/images/clock-milk-control.svg';
    static FILLED_BOTTLE_ICON = 'assets/images/filled-bottle.svg';
    static DUMP_ICON = 'assets/images/dump-icon.svg';
    static MILK_ICON = 'assets/images/milk-icon.svg';
    static SEARCH_ICON = 'assets/images/search-icon.svg';
    static FLASK_ICON = 'assets/images/flask-icon.svg';
    static COW_ICON_GREEN = 'assets/images/cow-icon-green.svg';
    static COW_ICON_GRAY = 'assets/images/cow-icon-gray.svg';
    static DRY_ICON = 'assets/images/dry-confirmation.svg';
    static WARNING_ICON = 'assets/images/warning-icon.svg'
    static COW_MILKING_GREEN_ICON = 'assets/images/cow-milking-green-icon.svg';
    static BELL_ICON = 'assets/images/bell-icon.svg';
    static EDIT_ICON = 'assets/images/edit-icon.svg';
    static ARROW_ICON = 'assets/images/arrow-icon.svg';
    static MILK_CONFIRMATION_ICON = 'assets/images/milk-confirmation-icon.svg';
    static SYNCHRONIZED_ICON = 'assets/images/loading.svg';
    static LOGO_HOMELEITE = 'assets/images/default-homeleite.png'
    static REPORT_IMAGE = 'assets/images/report-image.png'
}
